import {Component, ContentChildren, QueryList} from '@angular/core';
import {TvActionInputErrorComponent} from "../tv-action-input-error/tv-action-input-error.component";

@Component({
    selector: 'tva-error',
    templateUrl: './tv-action-error.component.html',
    styleUrls: ['./tv-action-error.component.scss']
})
export class TvActionErrorComponent {
    @ContentChildren(TvActionInputErrorComponent) errors: QueryList<TvActionInputErrorComponent>;

    constructor() {
    }

    hasErrorsShown(): boolean{
        let shown = true;
        if (this.errors?.length){
            shown = this.errors.some(error => error.isShown());
        }
        return shown;
    }
}
